/**
 * InfoBadge
 *
 * A tiny hover-tooltip badge for inline metric / tile explanations.
 * Used wherever a number on the dashboard could leave the viewer
 * wondering "what does this mean?" without warranting a full
 * <HelpInfo /> click-popover (HelpInfo is heavier — multiple steps,
 * a tip line, a panel that pushes content down).
 *
 * Usage:
 *   <InfoBadge text="Conversion rate = won leads / total leads." />
 *
 * The `text` is exposed via:
 *   - title=         native hover tooltip
 *   - aria-label=    screen readers + keyboard-focus reveal
 *   - tabIndex=0     so Tab navigation can land on it
 *   - focus ring     so keyboard users see they have focus
 *
 * Visual: subtle slate-grey idle, darker on hover. Doesn't shift
 * layout — fixed 16x16 inline-flex.
 */
import React from 'react';
import { Info } from 'lucide-react';

export default function InfoBadge({ text, size = 11, className = '' }) {
  if (!text) return null;
  return (
    <span
      role="img"
      tabIndex={0}
      aria-label={text}
      title={text}
      className={`ml-1 inline-flex h-4 w-4 cursor-help items-center justify-center rounded-full text-slate-400 hover:text-slate-600 focus:outline-none focus:ring-1 focus:ring-violet-400 ${className}`}
    >
      <Info size={size} />
    </span>
  );
}
